export const chartColors = ['#F1DEEA', '#A281E9', '#855FE8', '#623BC6', '#421DA0']

export const chartMainColor = '#A281E9'
